module.exports = __webpack_public_path__ + "img/Montenegro.b0edeece.png";